import api, { getBaseURL } from "./api"

export const fetchSymbols = (_year: string = "2023", _page: number = 1) => {
  return api.get(`/symbols`).then((res) => {
    console.log(res)

    return res?.data?.data?.symbols
  })
}

// Add this new function to your main.service.js file
export const fetchAllDealsForCSV = (
  _year: string,
  startDate: string,
  endDate: string,
  loginId: string = "",
  symbol: string = ""
) => {
  // Adding csv_download=true and limit=50000 as requested by senior developer
  let queryString = `page=1&sort=DESC&csv_download=true&limit=50000&startDate=${startDate}&endDate=${endDate}`

  if (symbol) {
    queryString += `&Symbol=${symbol}`
  }

  if (loginId) {
    queryString += `&Login=${loginId}`
  }

  // Return the full response instead of just data.data to get access to all fields
  return api.get(`/deals?` + queryString).then((res) => res.data)
}

// Keep your existing fetchDeals function
export const fetchDeals = (
  _year: string,
  _page: number = 1,
  startDate: string,
  endDate: string,
  loginId: string = "",
  symbol: string = ""
) => {
  let queryString = `page=${_page}&sort=DESC&startDate=${startDate}&endDate=${endDate}`

  if (symbol) {
    queryString += `&Symbol=${symbol}`
  }

  if (loginId) {
    queryString += `&Login=${loginId}`
  }

  return api.get(`/deals?` + queryString).then((res) => res?.data?.data)
}

// API service functions
export const fetchAllOpenPositionsForCSV = (
  _year: string,
  startDate: string,
  endDate: string,
  loginId: string = "",
  symbol: string = ""
) => {
  // Adding csv_download=true and limit=50000 as requested to fetch all data at once
  let queryString = `page=1&sort=DESC&csv_download=true&limit=50000&startDate=${startDate}&endDate=${endDate}`

  if (symbol) {
    queryString += `&Symbol=${symbol}`
  }

  if (loginId) {
    queryString += `&Login=${loginId}`
  }

  // Return the full response instead of just data.data to get access to all fields
  return api.get(`/open-positions?` + queryString).then((res) => res.data)
}

// Keep your existing fetchOpenPositions function
export const fetchOpenPositions = (
  _year: string,
  _page: number = 1,
  startDate: string,
  endDate: string,
  loginId: string = "",
  symbol: string = ""
) => {
  let queryString = `page=${_page}&sort=DESC&startDate=${startDate}&endDate=${endDate}`

  if (symbol) {
    queryString += `&Symbol=${symbol}`
  }

  if (loginId) {
    queryString += `&Login=${loginId}`
  }

  return api.get(`/open-positions?` + queryString).then((res) => res?.data?.data)
}

export const fetchProfitLoss = (
  profit: boolean,
  page = 1,
  startDate: string,
  endDate: string,
  loginId: string = "",
  symbol: string = "",
  Profit: string = "",
  Loss: string = ""
) => {
  let queryString = `page=${page}&sort=${profit ? "ASC" : "DESC"}`

  if (startDate) {
    queryString += `&startDate=${startDate}`
  }

  if (endDate) {
    queryString += `&endDate=${endDate}`
  }

  if (symbol) {
    queryString += `&Symbol=${symbol}`
  }

  if (loginId) {
    queryString += `&Login=${loginId}`
  }

  if (Profit) {
    queryString += `&Profit=${Profit}`
  }

  if (Loss) {
    queryString += `&Loss=${Loss}`
  }

  console.log("QUERY STRING")
  console.log(queryString)
  console.log(startDate)
  console.log(endDate)

  return api
    .get(`/${profit ? "loss-deals" : "profit-deals"}?${queryString}`)
    .then((res) => res?.data?.data)
}

//}/scam-trade

export const fetchScamTrades = (
  _year: string,
  _page: number = 1,
  startDate: string,
  endDate: string,
  loginId: string = "",
  symbol: string = ""
) => {
  let queryString = `page=${_page}`

  if (startDate) {
    queryString += `&startDate=${startDate}`
  }

  if (endDate) {
    queryString += `&endDate=${endDate}`
  }

  if (symbol) {
    queryString += `&Symbol=${symbol}`
  }

  if (loginId) {
    queryString += `&Login=${loginId}`
  }

  return api
    .get(`/scam-trade?${queryString}`)
    .then((res) => res?.data?.data?.scam_trades)
}

export const getFrequentTradesURL = (
  startDate: string,
  endDate: string,
  loginId?: number,
  symbol: string = "",
  page: number = 1,
  download: boolean = false,
  mins?: number,
  startProfit?: number,
  endProfit?: number
) => {
  let queryString = `sort=DESC`

  if (!download) {
    queryString += `&page=${page}`
  }

  if (loginId) {
    queryString += `&Login=${loginId}`
  }

  if (symbol) {
    queryString += `&symbol=${symbol}`
  }

  if (startDate) {
    queryString += `&startDate=${startDate}`
  }

  if (endDate) {
    queryString += `&endDate=${endDate}`
  }

  if (mins) {
    queryString += `&mins=${mins}`
  }

  if (download) {
    queryString += `&csv_download=${true}`
  } else {
    queryString += `&limit=${50}`
  }

  if (typeof startProfit != undefined) {
    queryString += `&startProfit=${startProfit ? startProfit : 0}`
  }

  if (typeof endProfit != undefined) {
    queryString += `&endProfit=${endProfit ? endProfit : 0}`
  }

  return getBaseURL() + `/frequently?${queryString}`
}

export const fetchFrequentTrades = (
  startDate: string,
  endDate: string,
  loginId?: number,
  symbol: string = "",
  page: number = 1,
  download: boolean = false,
  mins: number = 0,
  startProfit?: number,
  endProfit?: number
) => {
  return api
    .get(
      getFrequentTradesURL(
        startDate,
        endDate,
        loginId,
        symbol,
        page,
        download,
        mins,
        startProfit,
        endProfit
      )
    )
    .then((res) => res?.data?.data)
}
// API service functions to add to your main.service.js
export const fetchAllOpenPositionsByDaysForCSV = (
  days: number,
  _year: string,
  startDate: string,
  endDate: string,
  loginId: string = "",
  symbol: string = "",
  positionId: string = ""
) => {
  // Adding csv_download=true and limit=50000 to fetch all data at once
  let queryString = `page=1&sort=DESC&csv_download=true&limit=50000&startDate=${startDate}&endDate=${endDate}&days=${days}`

  if (symbol) {
    queryString += `&Symbol=${symbol}`
  }

  if (loginId) {
    queryString += `&Login=${loginId}`
  }

  if (positionId) {
    queryString += `&Position=${positionId}`
  }

  // Return the full response instead of just data.data to get access to all fields
  return api.get(`/open-positions-days?` + queryString).then((res) => res.data)
}
export const fetchOpenPositionsByDays = (
  _days: number,
  _year: string,
  _page: number = 1,
  startDate: string,
  endDate: string,
  loginId: string = "",
  symbol: string = "",
  PositionID: string = ""
) => {
  let queryString = `page=${_page}&days=${_days}`

  if (startDate) {
    queryString += `&startDate=${startDate}`
  }

  if (endDate) {
    queryString += `&endDate=${endDate}`
  }

  if (symbol) {
    queryString += `&Symbol=${symbol}`
  }

  if (loginId) {
    queryString += `&Login=${loginId}`
  }

  if (PositionID) {
    queryString += `&PositionID=${PositionID}`
  }

  return api
    .get(`/open-positions-days?` + queryString)
    .then((res) => res?.data?.data)
}

export const fetchAllProfitLossForCSV = (
  profit: boolean,
  startDate: string,
  endDate: string,
  loginId: string = "",
  symbol: string = "",
  Profit: string = "",
  Loss: string = ""
) => {

  let queryString = `page=1&sort=${profit ? "ASC" : "DESC"}&csv_download=true&limit=50000`

  if (startDate) {
    queryString += `&startDate=${startDate}`
  }

  if (endDate) {
    queryString += `&endDate=${endDate}`
  }

  if (symbol) {
    queryString += `&Symbol=${symbol}`
  }

  if (loginId) {
    queryString += `&Login=${loginId}`
  }

  if (Profit) {
    queryString += `&Profit=${Profit}`
  }

  if (Loss) {
    queryString += `&Loss=${Loss}`
  }


  return api.get(`/${profit ? "loss-deals" : "profit-deals"}?${queryString}`)
    .then((res) => res.data)
}
export const fetchAllScamTradesForCSV = (
  _year: string,
  startDate: string,
  endDate: string,
  loginId: string = "",
  symbol: string = ""
) => {

  let queryString = `page=1&sort=DESC&csv_download=true&limit=50000&startDate=${startDate}&endDate=${endDate}`
  
  if (symbol) {
    queryString += `&Symbol=${symbol}`
  }
  
  if (loginId) {
    queryString += `&Login=${loginId}`
  }
  

  return api.get(`/scam-trade?${queryString}`).then((res) => res.data)
}
